export const FORMATION_RESET = "FORMATION_RESET";
export const FORMATION_SET_ERROR = "FORMATION_SET_ERROR";
export const FORMATION_SET_ITEMS = "FORMATION_SET_ITEMS";
export const FORMATION_TOGGLE_LOADING = "FORMATION_TOGGLE_LOADING";
